import fetch from 'auth/FetchInterceptor'

const PaymentService = {}

// Get all available plans
PaymentService.getPlans = async function () {
	const normalizePlan = (plan) => ({
		id: plan.id || plan.uuid,
		title: plan.title,
		is_trial: plan.is_trial ?? plan.isTrial ?? false,
		price: plan.price ?? 0,
		price_crossed: plan.price_crossed ?? plan.priceCrossed ?? 0,
		short_des: plan.short_des ?? plan.shortDes ?? '',
		dialer: plan.dialer ?? false,
		call_broadcast: plan.call_broadcast ?? plan.callBroadcast ?? false,
		agent_ia: plan.agent_ia ?? plan.agentIa ?? plan.messaging ?? false,
		agentIa: plan.agentIa ?? plan.agent_ia ?? plan.messaging ?? false,
		phonebook_limit: plan.phonebook_limit ?? plan.phonebookLimit ?? 0,
		agent_access: plan.agent_access ?? plan.agentAccess ?? false,
		device_limit: plan.device_limit ?? plan.deviceLimit ?? 0,
		days: plan.days ?? 0,
		createdAt: plan.createdAt || plan.created_at || null
	});

	// 1) New Spring endpoint dedicated to subscription
	try {
		const response = await fetch({
			url: '/subscription/plans',
			method: 'get'
		});
		if (response && response.success && Array.isArray(response.data)) {
			return {
				success: true,
				data: response.data.map(normalizePlan)
			};
		}
	} catch (e) {
		// fallback below
	}

	// 2) Fallback to existing plan endpoints (paginated or non-paginated)
	const fallback = await fetch({
		url: '/plan/get_all_plans',
		method: 'get'
	});

	if (Array.isArray(fallback)) {
		return {
			success: true,
			data: fallback.map(normalizePlan)
		};
	}

	if (fallback && Array.isArray(fallback.content)) {
		return {
			success: true,
			data: fallback.content.map(normalizePlan)
		};
	}

	if (fallback && fallback.success && Array.isArray(fallback.data)) {
		return {
			success: true,
			data: fallback.data.map(normalizePlan)
		};
	}

	return { success: false, data: [] };
}

// Get specific plan details by ID
PaymentService.getPlanDetails = function (id) {
	return fetch({
		url: '/user/get_plan_details',
		method: 'post',
		data: { id }
	})
}

// Get current subscription for connected manager
PaymentService.getCurrentSubscription = function () {
	return fetch({
		url: '/subscription/current',
		method: 'get'
	})
}

// Get payment gateway configuration
PaymentService.getPaymentDetails = function () {
	return fetch({
		url: '/user/get_payment_details',
		method: 'get'
	})
}

// Create Stripe checkout session
PaymentService.createStripeSession = function (planId) {
	return fetch({
		url: '/user/create_stripe_session',
		method: 'post',
		data: { planId }
	})
}

// Start free trial for a plan
PaymentService.startFreeTrial = function (planId) {
	return fetch({
		url: `/subscription/select-plan?id=${encodeURIComponent(planId)}`,
		method: 'post'
	})
}

// Select plan for connected manager
PaymentService.selectSubscriptionPlan = function (planId) {
	return fetch({
		url: `/subscription/select-plan?id=${encodeURIComponent(planId)}`,
		method: 'post'
	})
}

// Pay with Razorpay
PaymentService.payWithRazorpay = function (rz_payment_id, plan, amount) {
	return fetch({
		url: '/user/pay_with_rz',
		method: 'post',
		data: { rz_payment_id, plan, amount }
	})
}

// Create PayPal order
PaymentService.createPayPalOrder = function (planId) {
	return fetch({
		url: '/user/create_paypal_order',
		method: 'post',
		data: { planId }
	})
}

// Pay with PayPal
PaymentService.payWithPayPal = function (orderID, plan) {
	return fetch({
		url: '/user/pay_with_paypal',
		method: 'post',
		data: { orderID, plan }
	})
}

export default PaymentService
